import ButtonCustom from '@/components/ui/ui-react-antd/MyButton/Button'
import { Result } from 'antd'
import type { ReactNode } from 'react'
import { Component } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  // componentDidCatch(error: Error, info: ErrorInfo) {
  // }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="Có lỗi xảy ra!"
          subTitle="Hệ thống xảy ra lỗi, vui lòng tải lại trang để tiếp tục sử dụng!"
          extra={
            <div className="d-flex justify-content-center">
              <ButtonCustom onClick={() => window.location.reload()}>Tải lại trang</ButtonCustom>
            </div>
          }
        />
      )
    }

    return this.props.children
  }
}
